"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filtersObjectToQueryString = exports.defaultTuningOptions = exports.inboxTuningOptions = exports.defaultFilterOptions = exports.SortOrder = void 0;
const feed_factory_models_ndtrc_1 = require("@feed-factory/feed-factory.models.ndtrc");
var SortOrder;
(function (SortOrder) {
    SortOrder["Ascending"] = "ASC";
    SortOrder["Descending"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
const WEBFORM_ITEMS = "feed:01_p_rm_webform;feed:01_p_am_webform;feed:00_rf_webform";
exports.defaultFilterOptions = [
    {
        label: "tuning.wfstatus",
        translated: true,
        field: "wfstatus",
        type: "multiselect",
        options: feed_factory_models_ndtrc_1.WfStatusOptions,
    },
    {
        label: "tuning.webformMarker",
        translated: true,
        field: "markers",
        type: "boolean",
    },
    {
        label: "tuning.eventDateRangeStart",
        translated: true,
        field: "eventDateRangeStart",
        type: "date",
        entityTypeFilter: "EVENEMENT",
    },
    {
        label: "tuning.eventDateRangeEnd",
        translated: true,
        field: "eventDateRangeEnd",
        type: "date",
        entityTypeFilter: "EVENEMENT",
    },
    {
        label: "tuning.updatedSince",
        translated: true,
        field: "lastupdated",
        type: "date",
    },
    {
        label: "tuning.alluserorganisations",
        translated: true,
        field: "userorganisation",
        type: "boolean",
    },
];
const inboxFilterOptions = [
    {
        label: "tuning.wfstatus",
        translated: true,
        field: "wfstatus",
        type: "multiselect",
        value: "readyforvalidation",
        options: feed_factory_models_ndtrc_1.WfStatusOptions,
    },
    {
        label: "tuning.updatedSince",
        translated: true,
        field: "lastupdated",
        type: "date",
        value: "2021-01-01",
    },
    {
        label: "tuning.alluserorganisations",
        translated: true,
        field: "userorganisation",
        type: "boolean",
        value: false,
    },
];
exports.inboxTuningOptions = {
    sortField: "modified",
    sortOrder: SortOrder.Descending,
    search: "",
    filters: inboxFilterOptions,
};
exports.defaultTuningOptions = {
    sortField: "modified",
    sortOrder: SortOrder.Descending,
    search: "",
    filters: exports.defaultFilterOptions,
};
const filtersObjectToQueryString = (filters) => filters
    .filter((filter) => filter.value && filter.value !== "")
    .map((filter) => {
    // Custom behaviour for userorganisation: turn boolean into string
    if (filter.field === "userorganisation") {
        return filter.value ? `${filter.field}=*` : null;
    }
    if (filter.field === "markers") {
        return filter.value ? `${filter.field}=${WEBFORM_ITEMS}` : null;
    }
    return `${filter.field}=${filter.value}`;
})
    .filter((filterString) => {
    return filterString && filterString !== "";
})
    .join("&");
exports.filtersObjectToQueryString = filtersObjectToQueryString;
//# sourceMappingURL=TuningProps.js.map